import moment from 'moment-timezone'
import BeacontypeEntity, { IBeacontypeProps, EmptyBeacontypeEntityFactory, EmptyBeacontypePropsFactory } from './Beacontype'
import AreaEntity, { IAreaProps, EmptyAreaEntityFactory, EmptyAreaPropsFactory } from './Area'
import OptionsEntity from './Options'

export interface IBeaconProps {
  id: string
  beacontype: IBeacontypeProps
  beacontypeId?: string | null
  area: IAreaProps
  name: string
  major: number | null
  minor: number | null
  zeacon: string
  battery: number
  tagNumberEnabled: boolean
  partnersEnabled: boolean
  bodyTemperatureEnabled: boolean
  healthCheckEnabled: boolean
  measuringThermometerEnabled: boolean
  isBattery: boolean
  isFixed: boolean
  isNoApprovalReq: boolean
  sendingAt: string
  exhaustingAt: string
  batteryAt: string
  createdAt: string
  order: number
}

export interface IBeaconList {
  entities: BeaconEntity[]
  options: OptionsEntity
}

export default class BeaconEntity {
  private _props: IBeaconProps

  constructor(props: IBeaconProps) {
    this._props = props
  }

  get props(): IBeaconProps {
    return this._props
  }

  get id(): string {
    return this._props.id
  }

  get beacontype(): BeacontypeEntity {
    return EmptyBeacontypeEntityFactory(this._props.beacontype)
  }

  get area(): AreaEntity {
    return EmptyAreaEntityFactory(this._props.area)
  }

  get major(): number | null {
    return this._props.major
  }

  get minor(): number | null {
    return this._props.minor
  }

  get tagNumberEnabled(): boolean {
    return this._props.tagNumberEnabled
  }

  get partnersEnabled(): boolean {
    return this._props.partnersEnabled
  }

  get bodyTemperatureEnabled(): boolean {
    return this._props.bodyTemperatureEnabled
  }

  get healthCheckEnabled(): boolean {
    return this._props.healthCheckEnabled
  }

  get measuringThermometerEnabled(): boolean {
    return this._props.measuringThermometerEnabled
  }

  get isNoApprovalReq(): boolean {
    return this._props.isNoApprovalReq
  }

  get sendingAt(): string {
    return this._props.sendingAt ? moment(this._props.sendingAt).format('YYYY/MM/DD HH:mm') : ''
  }

  get exhaustingAt(): string {
    return this._props.exhaustingAt ? moment(this._props.exhaustingAt).format('YYYY/MM/DD HH:mm') : ''
  }

  get order(): number {
    return this._props.order
  }

  set order(value: number) {
    this._props.order = value
  }

  /* eslint camelcase: 0 */
  get area_id(): string {
    return this._props.area.name
  }

  get beacontype_id(): number {
    return this._props.beacontype.id as unknown as number
  }

  get beacontype_str(): string {
    return this._props.beacontype.name
  }

  get sending_at(): string {
    return this._props.sendingAt ? moment(this._props.sendingAt).format('YYYY/MM/DD') : ''
  }

  get exhausting_at(): string {
    return this._props.exhaustingAt ? moment(this._props.exhaustingAt).format('YYYY/MM/DD') : ''
  }

  get created_at(): string {
    return this._props.createdAt ? moment(this._props.createdAt).format('YYYY/MM/DD') : ''
  }

  get battery_at(): string {
    return this._props.batteryAt ? moment(this._props.batteryAt).format('YYYY/MM/DD') : ''
  }

  get battery(): string {
    return this._props.battery >= 0 ? this._props.battery + '%' : ''
  }

  get send_battery(): string {
    return this._props.isBattery ? 'ON' : 'OFF'
  }

  get zeacon(): string {
    return this._props.zeacon
  }
}

export const headers = [
  { text: 'MajorID', value: 'major' },
  { text: 'MinorID', value: 'minor' },
  { text: 'ZeaconID', value: 'zeacon' },
  { text: 'タイプ', value: 'beacontype_id' },
  { text: 'フロア名', value: 'floor_id', sortable: false },
  { text: 'エリア名', value: 'area_id', sortable: false },
  { text: '送付日', value: 'sending_at' },
  { text: '消耗日', value: 'exhausting_at' },
  { text: '電池', value: 'send_battery' },
  { text: '残量', value: 'battery' },
  { text: '更新日', value: 'battery_at' },
  { text: '登録日', value: 'created_at' },
  { text: '', value: 'actions', sortable: false, width: '80' }
]

export const EmptyBeaconPropsFactory = (props?: Partial<IBeaconProps>): IBeaconProps => ({
  id: '',
  beacontype: EmptyBeacontypePropsFactory(),
  area: EmptyAreaPropsFactory(),
  name: '',
  major: null,
  minor: null,
  zeacon: '',
  battery: 0,
  tagNumberEnabled: true,
  partnersEnabled: true,
  bodyTemperatureEnabled: true,
  healthCheckEnabled: true,
  measuringThermometerEnabled: false,
  isBattery: false,
  isFixed: false,
  isNoApprovalReq: false,
  sendingAt: '',
  exhaustingAt: '',
  batteryAt: '',
  createdAt: '',
  order: 0,
  ...props
})

export const EmptyBeaconEntityFactory = (props?: Partial<IBeaconProps>): BeaconEntity => {
  return new BeaconEntity(EmptyBeaconPropsFactory(props))
}
